import React, { useRef, useState } from 'react'
import { MdAddCircle } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import fotoVacia from '../../paginas/img/fotoVacia.jpg'

const AgregarImagenes = ({ imagenes, setImagenes, setImagenesNuevas, setBorraImagenes }) => {


  const hiddenFileInput = React.useRef(null);

  const handleClick = event => { hiddenFileInput.current.click(); };

  const handleChange = e => {
    if (imagenes.length < 4) {
      let picture = e.target.files[0]

      setImagenes([...imagenes, { imagePrev: URL.createObjectURL(picture), imagen: picture, nueva: true }])
      setImagenesNuevas(true)
    }
  }

  const BorraImagenes = () => {
    setImagenes([])
    setBorraImagenes(true)
    setImagenesNuevas(true)

  }

  return (
    <div>
      <div className="FotoPrev">
        <img src={imagenes[0] === undefined ? fotoVacia : imagenes[0].imagePrev} />
      </div>
      <div className='AgregarImagenes'>
        {imagenes.length > 0 ?
          imagenes.map((item, index) => {
            return (
              <div className='AddImagen' key={index}>
                <img src={item === undefined ? fotoVacia : item.imagePrev} />
                <div style={{ position: 'absolute', top: '25%', right: '35%', }}><span>{index + 1}</span></div>
              </div>
            )
          })
          : <div className='AddImagen'><img src={fotoVacia} /></div>
        }
      </div>


      <div style={{ display: 'flex' }}>
        <div style={{ flex: 9 }}>
          <button onClick={handleClick} type='button' className='BtnAddImagen'>
            <MdAddCircle /> Sube foto
          </button>
          <input type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: 'none' }}
          />
        </div>
        <div style={{ flex: 3, marginLeft: 5 }}>
          <button type='button' onClick={() => BorraImagenes()} className='BtnAddImagenTrash'>
            <FaTrashAlt />
          </button>
        </div>
      </div>

    </div>
  )
}

export default AgregarImagenes